import React, { useEffect, useState, useMemo, useCallback, useRef } from 'react';
import { Autocomplete, TextField, Button, Paper, Dialog, Box, Typography, Snackbar
  , TableContainer, Table, TableBody, TableHead, TableRow, TableCell, DialogTitle, DialogContent
 } from '@mui/material';
import { AgGridReact } from 'ag-grid-react';
import { ModuleRegistry, AllCommunityModule, themeQuartz } from 'ag-grid-community';
import { useGetListOrdersMutation, useGetOrderDetailsMutation, useConfirmOrderMutation, useCancelOrderMutation
  , useGetOrderByIdMutation
 } from "../../services/orders";
import LoadingPage from '../loadingPage';
import "react-day-picker/style.css";
import moment from 'moment';
import DateRange from '../tools/daterange';
import ConfirmDialog from '../tools/comfirmDialog';

export default function OrderManager() {
  const [getListOrders, listOrdersResult] = useGetListOrdersMutation();
	const [getOrderDetails, orderDetailsResult] = useGetOrderDetailsMutation();
	const [confirmOrder, confirmOrderResult] = useConfirmOrderMutation();
  const [cancelOrder, cancelOrderResult] = useCancelOrderMutation();
  const [getOrderById, getOrderByIdResult] = useGetOrderByIdMutation();
  const [dataLoaded, setDataLoaded] = useState([]);
  const [columns, setCoumns] = useState([]);
  const [gridHeight, setGridHeight] = useState(300);
  const [openDetail, setOpenDetail] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState({});
	const [range, setRange] = useState({from: moment().startOf('month'), to: moment()});
  const [alert, setAlert] = useState(false);
  const [dataLoadedDetail, setDataLoadedDetail] = useState([]);
  const [orderById, setOrderById] = useState({});
  const [confirm, setConfirm] = useState(false);

  ModuleRegistry.registerModules([ AllCommunityModule ]);
  useEffect(() => {
    getListOrders({"fromdate": moment(range.from).format('YYYY-MM-DD')
					, "todate": moment(range.to).format('YYYY-MM-DD')});
    const divHeader = document.getElementById('divHeader');
    setGridHeight(window.innerHeight - (divHeader?divHeader.clientHeight:0) - 72);
  }, []);

  useEffect(() => {
    if(listOrdersResult && listOrdersResult.data){
      const dt = JSON.parse(listOrdersResult.data);
      setDataLoaded(dt);
			if(dt.length > 0)
      	getCoumns(dt[0]);
    }
  }, [listOrdersResult]);

  useEffect(() => {
    if(orderDetailsResult && orderDetailsResult.data){
      const dt = JSON.parse(orderDetailsResult.data);
      setDataLoadedDetail(dt);
    }
  }, [orderDetailsResult]);

  useEffect(() => {
    if(getOrderByIdResult && getOrderByIdResult.data){
      const dt = JSON.parse(getOrderByIdResult.data);
      setOrderById(dt.length?dt[0]:{});
    }
  }, [getOrderByIdResult]);

  const getDataView=()=>{
    getListOrders({"fromdate": moment(range.from).format('YYYY-MM-DD')
					, "todate": moment(range.to).format('YYYY-MM-DD')});
  }

  const confirmText = "Xác nhận xuất hóa đơn?";
  const finishedText = "Xác nhận hóa đơn đã giao hàng thành công?";

  useEffect(() => {
    if(confirmOrderResult.data)
    {
      const dt = JSON.parse(confirmOrderResult.data);
      if(dt.length && dt[0].ID){
        setAlert("Duyệt đơn hàng thành công!");
        getDataView();
        setConfirm(false);
        setOpenDetail(false);
      }
      else if(dt.length && dt[0].Finished){
        setAlert("Đã giao hàng thành công!");
        getDataView();
        setConfirm(false);
        setOpenDetail(false);
      }
      else{
        if(dt.length && dt[0].ERROR)
          setAlert(dt[0].ERROR);
        else
          setAlert("Lỗi kết nối vui lòng thử lại sau!");
      }
    }
  }, [confirmOrderResult]);

  const cancelText = "Xác nhận hủy đơn hàng?";

  const onConfirm=async()=>{
    if(confirm == cancelText){
      const result = await cancelOrder({orderid: selectedRecord.id});
      if (!result || result.error) {
        setAlert("Lỗi kết nối, vui lòng thử lại!");
      }
    }
    else if(confirm == confirmText){
      const result = await confirmOrder({orderid: selectedRecord.id, status: 3});
      if (!result || result.error) {
        setAlert("Lỗi kết nối, vui lòng thử lại!");
      }
    }
    else if(confirm == finishedText){
      const result = await confirmOrder({orderid: selectedRecord.id, status: 6});
      if (!result || result.error) {
        setAlert("Lỗi kết nối, vui lòng thử lại!");
      }
    }
  }

  useEffect(() => {
    if(cancelOrderResult.data)
    {
      const dt = JSON.parse(cancelOrderResult.data);
      if(dt.length && dt[0].ID){
        setAlert("Hủy đơn hàng thành công!");
        getDataView();
        setConfirm(false);
        setOpenDetail(false);
      }
      else{
        if(dt.length && dt[0].ERROR)
          setAlert(dt[0].ERROR);
        else
          setAlert("Lỗi kết nối vui lòng thử lại sau!");
      }
    }
  }, [cancelOrderResult]);

  const getCoumns=(item)=>{
    const cols = Object.keys(item).map((key) => {
      return {
        field: key,
        filter: true,
        resizable: true,
        hide: ((key != 'code' && key != 'fullname' && key != 'createdat' && key != 'totalmoney' && key != 'statusname') ? true : false),
        cellStyle: () => ((key=="totalmoney")
        ?{
          display: "flex",
          alignItems: "right",
          justifyContent: "right",
        }:null),
        width: (key == "fullname" ? 300 : 150),
        cellRenderer: (props) => (//key == "fullname" ? CustomCell(props) : 
					key == "createdat" ? moment(props.value).format('DD/MM/YYYY') 
					: key == "totalmoney" ? props.value.toLocaleString(): props.value)
      }
    });
    cols.push({
      field: 'Actions', width: 150, resizable: true, 
      cellRenderer: (props) => {
        const handleClick = () => {
          setSelectedRecord(props.data);
          getOrderDetails({orderid: props.data.id});
          getOrderById({orderid: props.data.id});
          setOpenDetail(true);
        };
        return <Button onClick={handleClick} sx={{width: '100%'}}>Chi tiết</Button>;
      }
    });
    setCoumns(cols);
  }

  const CustomCell = (props) => {
    const handleClick = () => {
      setSelectedRecord(props.data);
			getOrderDetails({orderid: props.data.id});
      getOrderById({orderid: props.data.id});
      setOpenDetail(true);
    };
    return <Button onClick={handleClick}>{props.data.fullname}</Button>;
  };

  const getRowClass = useCallback(params => {
    if (params.node.rowIndex % 2 === 1) {
        return "grid-odd-rows";
    }
    if (params.node.rowPinned === 'bottom') {
      return "text-bold";
    }
  }, []);

  const myTheme = themeQuartz.withParams({
    // borderColor: "#9696C8",
    wrapperBorder: false,
    headerRowBorder: false,
    // rowBorder: { style: "dotted", width: 1 },
    columnBorder: { style: "dashed", color: '#9696C8' },
    headerColumnBorder: { style: 'solid', width: 1, color: '#ccc' },
  });

  const theme = useMemo(() => {
    return myTheme;
  }, []);

  const tableRow=(row, index)=>{
    return <TableRow key={`${row.StyleNo}${row.Colors}${row.size}`} className={index % 2 === 0 ? 'grid-odd-rows' : ''}>
              {dataLoadedDetail.length && Object.keys(dataLoadedDetail[0]).map((key) => (
              key!='Images' && key!='ImageSrcs'?<TableCell align={(key=='quantity'||key=='saleprice'||key=='price')?'right':'left'} 
              key={key} sx={{ border: '1px solid silver', padding: 1, fontSize: '1rem' }}>
                {(key!='quantity' && key!='saleprice' && key!='price')?row[key] : new Intl.NumberFormat('en-US', {
                  minimumFractionDigits: row['ProductName'].includes('%')?2:0,
                  maximumFractionDigits: row['ProductName'].includes('%')?2:0,
                }).format(row[key])} {row['ProductName'].includes('%') && key!='ProductName'?'%':''}
              </TableCell>:''
              ))
            }
          </TableRow>
  }

  const tableCellHeader=(key, tbl)=>{
    return key!='Images' && key!='ImageSrcs'?<TableCell align="center" key={key} sx={{ border: '1px solid silver', padding: 1, width: key=='ProductName'?'30%':'10%'
      , fontSize: '1rem', fontWeight: 'bold', backgroundColor: (tbl=='MTD' || tbl=='YTD')?'#ddfcff':'#ffecec' }}>{key}</TableCell>:''
  }

  return (
    <div style={{padding: '0 10px'}}>
      { (listOrdersResult.isLoading || orderDetailsResult.isLoading) && <LoadingPage /> }
      <div style={{marginTop: '20px'}}>
        <div id='divHeader'>
					<DateRange range={range} setRange={setRange} sx={{float: 'left'}} />
          <Button variant="contained" onClick={getDataView}
            sx={{ margin: '0 0 10px 10px' }}>View</Button>
        </div>
        <Paper sx={{ height: gridHeight, width: '100%', float: 'left' }}>
          <AgGridReact
            rowData={dataLoaded}
            columnDefs={columns}
            pagination={true}
            paginationPageSize={500}
            paginationPageSizeSelector={[200, 500, 1000]}
            getRowClass={getRowClass}
            theme={theme}
          />
        </Paper>
      </div>

      <Dialog onClose={()=>setOpenDetail(false)} open={openDetail} fullWidth maxWidth="lg"
        sx={{"& .MuiPaper-root": { margin: 0, width: '100%' }}} >
        <DialogTitle sx={{background: 'orange'}}>
          <Typography component="h1" variant="h6" sx={{textAlign: 'center'}}>
            {selectedRecord.fullname}
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Box sx={{paddingTop: '20px'}}>
            <Button variant="outlined" color="primary"
              sx={{ fontWeight: 600, borderRadius: 10, px: 3, mr: 1 }}
              onClick={()=>setConfirm(confirmText)}
              disabled={confirmOrderResult.isLoading || selectedRecord.status != 0 || ((orderById.CASHREMAIN||0) < (selectedRecord.totalmoney||0))}
            >Xác Nhận</Button>
            <Button variant="outlined" color="primary"
              sx={{ fontWeight: 600, borderRadius: 10, px: 3, mr: 1 }}
              onClick={()=>setConfirm(finishedText)}
              disabled={confirmOrderResult.isLoading || selectedRecord.status != 3}
            >Đã Giao</Button>
            <Button variant="outlined" color="warning"
              sx={{ fontWeight: 600, borderRadius: 10, px: 3, mr: 1 }}
              onClick={()=>setConfirm(cancelText)}
              disabled={confirmOrderResult.isLoading || selectedRecord.status != 0}
            >Hủy</Button>
            <Button variant="outlined" color="primary"
              sx={{ fontWeight: 600, borderRadius: 10, px: 3 }}
              onClick={()=>setOpenDetail(false)}
            >Đóng</Button>
          </Box>
          <Box sx={{paddingTop: '20px'}}>
            <Typography>
              Ngày đặt hàng: {moment(selectedRecord.createdat).format("DD/MM/YYYY HH:mm")}
            </Typography>
            <Typography sx={{mt: 1}}>
              Tổng tiền đơn hàng: <strong fontWeight={600} style={{color: "blue"}}>
                {(selectedRecord.totalmoney||0).toLocaleString()}₫</strong>
            </Typography>
            <Typography sx={{mt: 1}}>
              Tiền mặt còn lại: <strong fontWeight={600} style={{color: "green"}}>
                {(orderById.CASHREMAIN||0).toLocaleString()}₫</strong>
            </Typography>
            <Typography sx={{mt: 1}}>
              Địa chỉ giao hàng: {orderById.DCGH}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', mt: 1 }}>
            <TableContainer component={Paper}>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    {dataLoadedDetail.length ? Object.keys(dataLoadedDetail[0]).map((key) => (
                      tableCellHeader(key, 'MTD')
                    ))
                    :<TableCell></TableCell>}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {dataLoadedDetail.length ? dataLoadedDetail.map((row, index) => (
                    tableRow(row, index)
                  )):<TableRow></TableRow>}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </DialogContent>
      </Dialog>

      <Snackbar
        open={alert}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        autoHideDuration={6000}
        onClose={()=>setAlert(false)}
        message={alert}
      />

      <ConfirmDialog confirm={confirm} setConfirm={setConfirm} onConfirm={onConfirm}/>
    </div>
  )
}